import React from 'react';
import {
  FieldType,
  IDataModelFieldTypeInput,
} from '../../../../utils/apollo/graphqlSchema';
import { fieldTypeName, fieldTypesToSelectOptions } from '../utils';
import produce from 'immer';
import {
  PlainTypeWrapper,
  StyledTypeOverrideSelectMenu,
} from './DataModelerCdwTableGridUI';
import { DATA_MODEL_FIELD_TYPE_CONFIG } from '../../../../redux/slices/dataModeler/utils';

interface IProps {
  typeInput: IDataModelFieldTypeInput;
  setTypeInput?: (newInput: IDataModelFieldTypeInput) => void;
}

const SelectTypeOverride = ({ typeInput, setTypeInput }: IProps) => {
  const options = fieldTypesToSelectOptions(
    DATA_MODEL_FIELD_TYPE_CONFIG[typeInput.type].covertsTo,
  );
  const updateType = (newType: string) => {
    const newInput = produce(typeInput, (draft) => {
      draft.type = newType as FieldType;
      return draft;
    });
    setTypeInput?.(newInput);
  };

  if (options.length === 0) {
    return <PlainTypeWrapper>{fieldTypeName(typeInput.type)}</PlainTypeWrapper>;
  }
  return (
    <StyledTypeOverrideSelectMenu
      value={typeInput.type}
      options={options}
      onChange={updateType}
      disabled={!setTypeInput}
    />
  );
};

export default SelectTypeOverride;
